export let MAIN_COLOR = "#2cc84d";
export let SECONDARY_COLOR = "#e99828";
export let SECONDARY_LIGHT_COLOR = "#e9992857";
export let DARK_GREEN = "#205954";
export let LIGHT_GREEN = "#d8f5de";
export let LIGHT_GRAY = "#efefef";
export let TEXT_WHITE_COLOR = "#fff";
